export default "__VITE_ASSET__CjExO6KK__"